const INITIAL_STATE = {
  collectorsList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_COLLECTORS': {
      return { ...state, collectorsList: action.collectors };
    }
    default:
      return state;
  }
};
